/**
 * PATH: packages/kanban-host/src/allocation/allocationPopoverLayer.ts
 * FILE_ID: KANBANHOST-ALLOCATION-POPOVER-LAYER-001
 * PURPOSE: Shared stacking for portalled allocate / change-lane menus.
 * WHY: BUG-2026-08-03-PLACEMENT-MGR-ALLOCATE-UNDER-BACKDROP — Placement
 *      Manager uses backdrop z-70 / dialog z-71. AllocateChip and
 *      AllocationChip menus at z-60 painted through the translucent
 *      backdrop but received no clicks ("Add placement impossible").
 * NOTES FOR FUTURE AI: Keep these menus above PlacementManagerPanel
 *      (71) and aligned with email-hub AnchoredPopover (80). Why-popover
 *      uses max int and stays separate.
 */

/** Tailwind class for portalled allocate / lane / board pick menus. */
export const ALLOCATION_MENU_Z_CLASS = 'z-[80]' as const

/** Numeric twin for style={{ zIndex }} consumers / tests. */
export const ALLOCATION_MENU_Z_INDEX = 80 as const
